import { useEditor } from '@craftjs/core';
import { useCallback } from 'react';
import { downloadJsonFile } from 'src/helpers/file-helper';

const useLayoutExport = () => {
  const { query } = useEditor();

  const exportLayout = useCallback(
    (fileName?: string) => {
      downloadJsonFile(query.serialize(), fileName);
    },
    [query],
  );

  return {
    exportLayout,
  };
};

export default useLayoutExport;
